import { Link, createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { ButtonStyle2, ExternalLink } from "#components";
import {
  nativeApplication,
  useNativeApplicationIdentifierQuery,
  useNativeApplicationRevisionQuery,
  useNativeApplicationVersionQuery,
  usePushNotificationTokenQuery,
} from "#services";
import { css } from "#styled-system/css";

export const Route = createFileRoute("/debug/native-application")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  const nativeApplicationIdentifierQuery = useNativeApplicationIdentifierQuery();
  const nativeApplicationRevisionQuery = useNativeApplicationRevisionQuery();
  const nativeApplicationVersionQuery = useNativeApplicationVersionQuery();
  const pushNotificationTokenQuery = usePushNotificationTokenQuery();

  return (
    <main
      className={css({
        marginTop: "max(8px, env(safe-area-inset-top))",
        marginBottom: "max(8px, env(safe-area-inset-bottom))",
        marginLeft: "max(8px, env(safe-area-inset-left))",
        marginRight: "max(8px, env(safe-area-inset-right))",
      })}
    >
      <p>{t("%Identifier.0%") + ": " + nativeApplicationIdentifierQuery.data}</p>
      <p>
        {t("%Version.1%") +
          " " +
          nativeApplicationVersionQuery.data +
          ", " +
          t("%Revision.0%") +
          ": " +
          nativeApplicationRevisionQuery.data}
      </p>
      <p>{t("%PushNotification.0%") + ": " + pushNotificationTokenQuery.data}</p>

      <div
        className={css({
          display: "grid",
          gap: "8px",
          gridAutoColumns: "1fr",
          gridAutoFlow: "column",
          marginTop: "8px",
        })}
      >
        {[
          function () {
            const rate = Math.random() * 1.5 + 0.5;
            nativeApplication
              .speak("こんにちは、世界！ (再生速度: " + rate.toFixed(2) + ")", {
                pitch: 1.0,
                rate,
                volume: 1.0,
              })
              .catch(function (error) {
                toast.error(error instanceof Error ? error.message : String(error));
              });
          },
          function () {
            const pitch = Math.random() * 1.5 + 0.5;
            nativeApplication
              .speak("こんにちは、世界！ (ピッチ: " + pitch.toFixed(2) + ")", {
                pitch,
                rate: 1.0,
                volume: 1.0,
              })
              .catch(function (error) {
                toast.error(error instanceof Error ? error.message : String(error));
              });
          },
          function () {
            const volume = Math.random() * 1.0;
            nativeApplication
              .speak("こんにちは、世界！ (音量: " + volume.toFixed(2) + ")", {
                pitch: 1.0,
                rate: 1.0,
                volume,
              })
              .catch(function (error) {
                toast.error(error instanceof Error ? error.message : String(error));
              });
          },
        ].map(function (onClick, index) {
          return (
            <button
              className={css(ButtonStyle2.raw({ color: "white" }), {
                display: "block",
              })}
              key={index}
              onClick={onClick}
            >
              Speak {index + 1}
            </button>
          );
        })}
      </div>

      <div>
        {[1.0, 0.2].map(function (volume, index) {
          return (
            <button
              className={css(
                ButtonStyle2.raw({ color: "white", marginTop: "8px", width: "stretch" }),
                { display: "block" },
              )}
              key={index}
              onClick={function () {
                nativeApplication.play("alert.mp3", { volume }).catch(function (error) {
                  toast.error(error instanceof Error ? error.message : String(error));
                });
              }}
            >
              Play Sound (Volume: {volume.toFixed(2)})
            </button>
          );
        })}
      </div>

      <ExternalLink
        className={css(ButtonStyle2.raw({ color: "white", marginTop: "8px", width: "stretch" }), {
          display: "block",
        })}
        href="https://www.google.com/"
      >
        Open External Link
      </ExternalLink>

      <Link
        className={css(ButtonStyle2.raw({ color: "black", width: "stretch" }), {
          display: "block",
          marginTop: "24px",
        })}
        to="/management/utilities"
      >
        {t("%Back.0%")}
      </Link>
    </main>
  );
}
